// extracted by mini-css-extract-plugin
export default {"checkMark":"CheckMark_checkMark__lbwuL"};